import { createRouter, createWebHistory } from 'vue-router';
import ModalDialog from '@/pages/Modal.vue'
import DefaultPage from '@/pages/Default.vue'
import Home from '@/views/Home.vue';
import Login from '@/components/Login.vue';
import Profile from '@/views/Profile.vue';
import AdminUsers from '@/views/admin/Users.vue';
import AdminGroups from '@/views/admin/Groups.vue';
import AdminManufacturer from '@/views/admin/Manufacturers.vue';
import AdminComponents from '@/views/admin/Components.vue';
import ShopifyReports from '@/views/shopify/Reports.vue';
import ShopifyProducts from '@/views/shopify/Products.vue';
import ShopifyBagLines from '@/views/shopify/BagLines.vue';
import ShopifyPreview from '@/views/shopify/Preview.vue';
import ACLReports from '@/views/acl/Reports.vue';
import ACLCustomSubmission from '@/views/acl/CustomSubmission.vue';
import APITest from '@/views/acl/APITest.vue';
import ACLConfiguration from '@/views/acl/Configuration.vue';

const routes = [
  {
    path: '/',
    component: () => import('@/pages/Default.vue'),
    children: [
      { path: '', component: () => import('@/views/Home.vue') },
      { path: 'profile', component: () => import('@/views/Profile.vue'), meta: { requiresAuth: true } },

      // Admin section
      { path: 'admin/users', component: () => import('@/views/admin/Users.vue'), meta: { requiresAuth: true } },
      { path: 'admin/users/:id', component: () => import('@/views/admin/UserDetail.vue'), meta: { requiresAuth: true } },
      { path: 'admin/groups', component: () => import('@/views/admin/Groups.vue'), meta: { requiresAuth: true } },
      { path: 'admin/manufacturers', component: () => import('@/views/admin/Manufacturers.vue'), meta: { requiresAuth: true } },
      { path: 'admin/components', component: () => import('@/views/admin/Components.vue'), meta: { requiresAuth: true } },
      { path: 'admin/leagues', component: () => import('@/views/admin/Leagues.vue'), meta: { requiresAuth: true } },
      { path: 'admin/leagues/:id/edit', component: () => import('@/views/admin/LeagueEdit.vue'), meta: { requiresAuth: true } },
      { path: 'admin/shopify-collective', component: () => import('@/views/admin/ShopifyCollective.vue'), meta: { requiresAuth: true } },

      // Shopify Tools section
      { path: 'shopify/reports', component: () => import('@/views/shopify/Reports.vue'), meta: { requiresAuth: true } },
      { path: 'shopify/products', name: 'Products', component: () => import('@/views/shopify/Products.vue'), meta: { requiresAuth: true } },
      { path: 'shopify/products/add', name: 'ProductsAdd', component: () => import('@/views/shopify/Products.vue'), meta: { requiresAuth: true } },
      { path: 'shopify/products/:id', name: 'ProductsEdit', component: () => import('@/views/shopify/Products.vue'), meta: { requiresAuth: true } },
      { path: 'shopify/syncProducts', redirect: '/shopify/products' },
      { path: 'shopify/bag-lines', component: () => import('@/views/shopify/BagLines.vue'), meta: { requiresAuth: true } },
      { path: 'shopify/stamp-groups/:id/edit', component: () => import('@/views/shopify/StampGroupEdit.vue'), meta: { requiresAuth: true } },
      { path: 'shopify/preview', component: () => import('@/views/shopify/Preview.vue'), meta: { requiresAuth: true } },
      { path: 'shopify/webConfig', component: () => import('@/views/shopify/WebConfiguration.vue'), meta: { requiresAuth: true } },
      { path: 'shopify/utilities', component: () => import('@/views/shopify/Utilities.vue'), meta: { requiresAuth: true } },

      // Orders section
      { path: 'orders', component: () => import('@/views/orders/Orders.vue'), meta: { requiresAuth: true } },

      // Custom section
      { path: 'custom-bags/submit', component: () => import('@/views/custom-bags/CustomBagSubmission.vue'), meta: { requiresAuth: true } },
      { path: 'custom-bags/ai-designer', component: () => import('@/views/custom-bags/AIBagDesigner.vue'), meta: { requiresAuth: true } },
      { path: 'custom-bags/queue', component: () => import('@/views/custom-bags/CustomBagQueue.vue'), meta: { requiresAuth: true } },
      { path: 'custom-bags/submissions', component: () => import('@/views/custom-bags/BagLineSubmissions.vue'), meta: { requiresAuth: true } },
      { path: 'production/submissions', component: () => import('@/views/custom-bags/BagSubmissionQueue.vue'), meta: { requiresAuth: true } },
      { path: 'production/bookmarked-skus', name: 'BookmarkedSKUs', component: () => import('@/views/production/BookmarkedSKUs.vue'), meta: { requiresAuth: true } },
      { path: 'custom-boards/submit', component: () => import('@/views/custom-boards/CustomBoardSubmission.vue'), meta: { requiresAuth: true } },

      // ACL Tools section
      { path: 'acl/reports', component: () => import('@/views/acl/Reports.vue'), meta: { requiresAuth: true } },
      { path: 'acl/custom-submission', component: () => import('@/views/acl/CustomSubmission.vue'), meta: { requiresAuth: true } },
      { path: 'acl/api-test', component: () => import('@/views/acl/APITest.vue'), meta: { requiresAuth: true } },
      { path: 'acl/configuration', component: () => import('@/views/acl/Configuration.vue'), meta: { requiresAuth: true } },
    ]
  },
  {
    path: '/login',
    component: () => import('@/pages/Modal.vue'),
    children: [
      { path: '', component: () => import('@/components/Login.vue') }
    ]
  },
  {
    path: '/scene/:groupId/:variantId',
    component: () => import('@/views/ThreeScene.vue')
  },
  {
    path: '/fabricImage/custom/:customBagId',
    component: () => import('@/views/webBagRender.vue')
  },
  {
    path: '/fabricImage/submission/:submissionId',
    component: () => import('@/views/webBagRender.vue')
  },
  {
    path: '/fabricImage/:productId/:variantId',
    component: () => import('@/views/webBagRender.vue')
  },
  {
    path: '/kiosk',
    component: () => import('@/views/Kiosk.vue')
  },
  {
    path: '/bagFills',
    component: () => import('@/views/BagFills.vue')
  },
  {
    path: '/colorSVG',
    component: () => import('@/views/ColorSVG.vue')
  },
  {
    path: '/orders/:id/packing-list',
    component: () => import('@/views/orders/PackingList.vue')
  },
  {
    path: '/orders/bulk-ship',
    component: () => import('@/views/orders/BulkShipList.vue'),
  },
  {
    path: '/orders/bulk-ship/:id',
    component: () => import('@/views/orders/BulkShip.vue'),
  },
  {
    path: '/orders/packing-lists',
    component: () => import('@/views/orders/PackingListBatch.vue')
  }
];


const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach(async (to) => {
  if (to.meta.requiresAuth) {
    const { useUserStore } = await import('@/stores/user')
    const userStore = useUserStore()
    if (!userStore.user && !userStore.loading) {
      await userStore.fetchProfile()
    }
    if (!userStore.user) {
      return '/?session=expired'
    }
  }
})

export default router;